'use strict';

var GridToolbarFaresSurchargeUploadDirective = function GridToolbarFaresSurchargeUploadDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-fares-surcharge-upload.html'),
    controller: 'GridToolbarFaresSurchargeUploadController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarFaresSurchargeUploadDirective.$inject = [];
module.exports = GridToolbarFaresSurchargeUploadDirective;